/**
 * Finance Export Modal Styles
 * Design System compatible component styles
 * Modal.Body padding="default" handles vertical spacing
 */

.finance-export-modal {
    // Content container
    &__content {
        text-align: center;
    }

    // Description text
    &__description {
        font-size: 15px;
        color: #595959;
        margin: 0;
        line-height: 1.6;
    }
}
